import { ActionTree, MutationTree } from "vuex";
import axios, { AxiosResponse } from "axios";
import { GiftCardTier } from "@/models/gift-card-tiers/GiftCardTier";
import { GiftCardTiersPayload } from "@/models/gift-card-tiers/GiftCardTiersPayload";
import { GiftCardTiersState } from "@/models/store/GiftCardTiersState";
import { GlobalSetting } from "@/models/gift-card-tiers/GlobalSetting";
import { RootState } from "@/models/store/RootState";

export const findGiftCardTiersSetting = (settings: GlobalSetting[], ident: string): GiftCardTier | [] => {
  const tiers = settings.find(setting => setting.ident === ident);
  if (tiers && tiers.value) {
    return JSON.parse(tiers.value);
  }
  return [];
};

export const giftCardTiersState = {
  websiteTiers: [],
  callCenterTiers: [],
  loadingState: []
};

export const giftCardTiersActions: ActionTree<GiftCardTiersState, RootState> = {
  getGiftCardTiers: ({ commit, dispatch }) => {
    commit("addToLoadingState", "getting gift card tiers");
    return axios.get(`/global-settings`)
      .then((resp: AxiosResponse) => {
        const globalSettings = resp.data.large_global_settings;
        const websiteTiers = findGiftCardTiersSetting(globalSettings, "global_website_gift_card_tiers");
        const callCenterTiers = findGiftCardTiersSetting(globalSettings, "global_call_center_gift_card_tiers");
        commit("setWebsiteTiers", websiteTiers);
        commit("setCallCenterTiers", callCenterTiers);
        commit("removeFromLoadingState", "getting gift card tiers");
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        commit("removeFromLoadingState", "getting gift card tiers");
        throw new Error(err);
      });
  },
  submitGiftCardTiers: ({ commit, dispatch }, payload: GiftCardTiersPayload) => {
    commit("addToLoadingState", "submitting gift card tiers");
    return axios.patch(`/global-settings/${payload.ident}`, { value: payload.value })
      .then((resp: AxiosResponse) => {
        dispatch("snackbar/successMessage", "Successfully saved gift card tiers", { root: true });
        commit("removeFromLoadingState", "submitting gift card tiers");
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        commit("removeFromLoadingState", "submitting gift card tiers");
        throw new Error(err);
      });
  }
};

export const giftCardTiersMutations: MutationTree<GiftCardTiersState> = {
  addToLoadingState: (state: GiftCardTiersState, message: string) => {
    state.loadingState.push(message);
  },
  removeFromLoadingState: (state: GiftCardTiersState, message: string) => {
    state.loadingState = state.loadingState.filter(loadingMessage => loadingMessage !== message);
  },
  setCallCenterTiers: (state: GiftCardTiersState, giftCardTiers: GiftCardTier[]) => {
    state.callCenterTiers = giftCardTiers;
  },
  setWebsiteTiers: (state: GiftCardTiersState, websiteTiers: GiftCardTier[]) => {
    state.websiteTiers = websiteTiers;
  }
};

export default {
  name: "giftCardTiers",
  namespaced: true,
  state: giftCardTiersState,
  actions: giftCardTiersActions,
  mutations: giftCardTiersMutations
};
